// extracted by mini-css-extract-plugin
export default {"card":"newscard_card__bCpgj","date":"newscard_date__iCH9-","content":"newscard_content__A2fYs","header":"newscard_header__xo4hK","more":"newscard_more__ErPz4"};